import React from 'react';
import { Accordion, AccordionSummary, AccordionDetails, Typography, Tooltip, IconButton, Box } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FilterListOffIcon from '@mui/icons-material/FilterListOff';

type Props = {
	title: string;
	onClear: () => void;
	clearTooltip: string;
	defaultExpanded?: boolean;
	children: React.ReactNode;
};

export default function FilterAccordion(props: Props) {
	const { title, onClear, clearTooltip, defaultExpanded = true, children } = props;

	return (
		<Accordion defaultExpanded={defaultExpanded}>
			<AccordionSummary expandIcon={<ExpandMoreIcon />}>
				<Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
					<Typography>{title}</Typography>
					<Tooltip title={clearTooltip}>
						<IconButton
							size="small"
							onClick={(e) => {
								e.stopPropagation();
								onClear();
							}}
						>
							<FilterListOffIcon fontSize="small" />
						</IconButton>
					</Tooltip>
				</Box>
			</AccordionSummary>
			<AccordionDetails>{children}</AccordionDetails>
		</Accordion>
	);
}
